import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Card } from "primereact/card";
import { Button } from "primereact/button";
import useGeneralInformation from "./UseGeneralInformation";
import Notification from "../notification/Notification";
import GeneralInformationForm from "./GeneralInformationForm";
import {
  fetchGeneralInformation,
  resetFormDetail,
} from "./generalInformationSlice";
import { useParams } from "react-router-dom";
import AuditSidebar from "../../audit-sidebar/AuditSidebar";
import API_ROUTES from "../../../api-routes";
import PermissionGate from "~/components/PermissionGate";
import { setInfoData } from "../../../Pages/EntityOnboard/components/formSlice";
import { fetchGlobalEntityDetails } from "../../global-entities/globalEntitiesSlice";
import { fetchOrganizations } from "../../../Pages/EntityOnboard/components/entityOnboardSlice";

const GeneralInformation = ({ onboardType }) => {
  const [isSaveDisabled, setIsSaveDisabled] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const { id } = useParams();

  const generalStatus = useSelector((state) => state.generalInformation.status);
  const error = useSelector((state) => state.generalInformation.error);
  const generalInformation = useSelector(
    (state) => state.generalInformation.generalInformation,
  );
  const [isAuditSidebarVisible, setAuditSidebarVisible] = useState(false);

  useEffect(() => {
    if (generalStatus === "idle") {
      dispatch(fetchGeneralInformation(id));
      dispatch(fetchGlobalEntityDetails());
      dispatch(fetchOrganizations());
    }
  }, [generalStatus, dispatch, id]);

  const {
    isEditing,
    setIsEditing,
    successMessage,
    setSuccessMessage,
    handleEditClick,
    handleSaveClick,
    updateFormDetails,
    formRef,
    tempFormData,
  } = useGeneralInformation();

  if (generalStatus === "failed") {
    return <div>Error: {error}</div>;
  }

  const auditLabels = () => {
    return {
      create: "Entity Created",
      update: "Information Updated",
      delete: "Information Deleted",
    };
  };

  const handleFormStateChange = (isFormValid) => {
    setIsSaveDisabled(!isFormValid);
  };

  let resetForm = null;

  const handleDiscardClick = () => {
    if (resetForm) {
      dispatch(resetFormDetail(true));
      setIsEditing(false);
    }
  };

  return (
    <>
      {isAuditSidebarVisible && (
        <AuditSidebar
          heading="General Information"
          endpoint={API_ROUTES.FETCH_ENTITY_AUDIT}
          id={id}
          labels={auditLabels}
          setSidebarToggle={setAuditSidebarVisible}
          sidebarToggle={isAuditSidebarVisible}
          showUpdateActions={true}
        />
      )}
      <Card className="gen-card h-full">
        <div className="general-info-container flex justify-content-between formgrid grid grid-nogutter">
          <div>
            <p className="general-info">General Information</p>
            {/* <p className="general-info-para">
              This body copy will explain the information below by setting
              context
            </p> */}
          </div>
          <PermissionGate
            resource="entity"
            action="modify"
            resourceAttr={{
              entity_id: id,
              tenant_id: generalInformation?.data?.tenant_id,
            }}
          >
            <div className="flex gap-3">
              {isEditing ? (
                <div className="flex gap-2">
                  <button className="edit-button" onClick={handleDiscardClick}>
                    Discard
                  </button>
                  <Button
                    type="submit"
                    form="114490"
                    className={`add-btn  ${isSaveDisabled && "disable"}`}
                    disabled={isSaveDisabled}
                    onClick={handleSaveClick}
                    loading={isLoading}
                  >
                    {!isLoading && "Save Changes"}
                  </Button>
                </div>
              ) : (
                <>
                  <button
                    className="add-new-button"
                    onClick={() =>
                      setAuditSidebarVisible(!isAuditSidebarVisible)
                    }
                  >
                    View History
                    <span className="pi pi-history mb-1 ml-2" />
                  </button>
                  <button
                    className="btn-primary"
                    onClick={() => {
                      handleEditClick();
                      setIsSaveDisabled(true);
                      dispatch(resetFormDetail(false));
                    }}
                  >
                    Edit
                    <span className="pi pi-pencil text-xs ml-2"></span>
                  </button>
                </>
              )}
            </div>
          </PermissionGate>
          <Notification
            successMessage={successMessage}
            setSuccessMessage={setSuccessMessage}
          />
        </div>
        <GeneralInformationForm
          isEditing={isEditing}
          showGeneralInfo={false}
          onboardType={onboardType}
          ref={formRef}
          setFormDetails={updateFormDetails}
          handleFormStateChange={handleFormStateChange}
          resetFormFields={(resetFunc) => (resetForm = resetFunc)}
          setInfoData={setInfoData}
          setIsSaveDisabled={setIsSaveDisabled}
          isSaveDisabled={isSaveDisabled}
          isLoading={isLoading}
          setIsLoading={setIsLoading}
          key={`${generalStatus}`}
        />
      </Card>
    </>
  );
};

export default GeneralInformation;
